import BreadcrumbList from '@root/modules/Sellers/Stock/components/Breadcrumb';
import { Button, Input, Table } from 'antd';
import axios from 'axios';
import { useState } from 'react';

const OrderNormal = () => {
  const [token, setToken] = useState('');
  const crumbList = [
    { tittle: '외부 api 송출 내역', url: '' },
    { tittle: '외부 api 송출 내역 조회', url: '' }
  ];

  const columns = [
    {
      title: 'NO',
      dataIndex: 'id'
    },
    {
      title: 'Order Reference Number',
      dataIndex: 'orderNumber'
    },
    {
      title: 'Order Creation Date',
      dataIndex: 'orderDate'
    },
    {
      title: 'Order Status',
      dataIndex: 'status'
    },
    {
      title: 'Seller Status',
      dataIndex: 'sellerStatus'
    },
    {
      title: 'Sales Channel',
      dataIndex: 'saleChannel'
    },
    {
      title: 'Dangerous Goods Flag',
      dataIndex: 'dangerous',
      render: (value: boolean) => (value ? 'true' : 'false')
    },
    {
      title: 'Buyer Name',
      dataIndex: 'buyerName'
    },
    {
      title: 'Buyer Email',
      dataIndex: 'buyerEmail'
    },
    {
      title: 'Recipient Name',
      dataIndex: 'recipientName'
    },
    {
      title: 'Recipient Phone',
      dataIndex: 'recipientPhone'
    },
    {
      title: 'Recipient Country Code',
      dataIndex: 'recipientCountryCode'
    },
    {
      title: 'Shipping Address',
      dataIndex: 'shippingAddress'
    },
    {
      title: 'City',
      dataIndex: 'city'
    },
    {
      title: 'State/Province',
      dataIndex: 'state'
    },
    {
      title: 'Country',
      dataIndex: 'country'
    },
    {
      title: 'Postal Code',
      dataIndex: 'postalCode'
    },
    {
      title: 'Detailed Address Line 1',
      dataIndex: 'detailAddress'
    },
    {
      title: 'Detailed Address Line 2',
      dataIndex: 'detailAddress2'
    },
    {
      title: 'Packaging Method',
      dataIndex: 'packagingMethod'
    },
    {
      title: 'Shipping Method',
      dataIndex: 'shippingMethod'
    },
    {
      title: 'Courier Service Provider',
      dataIndex: 'courier'
    },
    {
      title: 'Tracking Number',
      dataIndex: 'trackingNumber'
    },
    {
      title: 'Seller Comment',
      dataIndex: 'sellerComment'
    },
    {
      title: 'Warehouse Comment',
      dataIndex: 'warehouseComment'
    },
    {
      title: 'Package Number',
      dataIndex: 'packageNumber'
    }
  ];

  const [totalPage, setTotalPage] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState();
  const fetchData = async (page: number) => {
    const res = await axios.get(
      `https://public-api.buskfulfillment.com/api/v1//warehouse/orders/normal?page=${page}`,
      {
        headers: {
          'X-Busk-Api-Token': token
        }
      }
    );
    console.log(res.data);
    setTotalPage(res.data.lastPage * 10);
    setData(res.data.data);
  };
  return (
    <div>
      <BreadcrumbList listBreadcrumb={crumbList} />
      <div className="busk-container">
        <div
          style={{
            display: 'flex',
            justifyContent: 'end',
            gap: 20,
            marginBottom: 20
          }}
        >
          <Input
            placeholder="token"
            value={token}
            onChange={(e) => setToken(e.target.value)}
          />
          <Button onClick={() => fetchData(0)}>Fetch</Button>
        </div>
        <Table
          pagination={{
            total: totalPage,
            current: currentPage,
            showSizeChanger: false,
            onChange: (page, limit) => {
              fetchData(page - 1);
              setCurrentPage(page);
            }
          }}
          scroll={{ x: 'max-content' }}
          columns={columns}
          dataSource={data}
        />
      </div>
    </div>
  );
};

export default OrderNormal;
